import { Component, h, Prop } from '@stencil/core';
import { SIZES } from '@local/models'

@Component({
  tag: 'cr-vstack',
  styleUrl: 'cr-vstack.css',
  shadow: true,
})
export class CrVstack {

  @Prop() size: SIZES | string = SIZES.MEDIUM;

  render() {
    return (
      <div class={`vstack ${this.size}`} part="inner">
        <slot></slot>
      </div>
    );
  }

}
